import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Dropdown } from "@/components/sidebar/Dropdown";
import { trackEvent } from "@/utils/trackEvent";
import { useIsMyDoc } from "@/utils/useIsMyDoc";

import type { DocumentModel } from "@/models/DocumentModel";

export const ReadWriteDropdown = observer(
  ({ doc, disabled }: { doc: DocumentModel; disabled?: boolean }) => {
    const t = useTranslations();
    const { publicRead, publicWrite } = doc;

    const isMyDoc = useIsMyDoc(doc);

    if (!isMyDoc) {
      return null;
    }

    const items = [
      {
        title: t("share.canView"),
        active: publicRead && !publicWrite,
        onClick: async () => {
          await doc.api.updatePublicFlags({ publicRead: true, publicWrite: false });
          if (doc.id) {
            trackEvent("share_permission_setting_changed", {
              setting: t("share.canView"),
              doc_id: doc.id,
            });
          }
        },
      },
      {
        title: t("share.canEdit"),
        active: publicRead && publicWrite,
        onClick: async () => {
          await doc.api.updatePublicFlags({ publicRead: true, publicWrite: true });
          if (doc.id) {
            trackEvent("share_permission_setting_changed", {
              setting: t("share.canEdit"),
              doc_id: doc.id,
            });
          }
        },
      },
    ];

    const toggleText = items.find((item) => item.active)?.title || t("share.canView");

    return (
      <Dropdown
        anchor="bottom end"
        toggleText={toggleText}
        toggleTextColor="text-gray-500"
        toggleTextInvertedBg
        items={items}
        className="ml-auto text-right"
        disabled={disabled}
      />
    );
  },
);
